import type { SalesTaxGroupRow } from '../api/masterdata';
import { codeLabel } from './codeLabel';

/**
 * A line's sales tax group as a person reads it — `CODE — description`, or just the stored code
 * while the company's live list is still loading, failed to load, or no longer contains it.
 *
 * Shared by the request form and the reviewer's screen so the two can never word the same line
 * differently. Takes the list in the loose shape both screens already hold (any phase; `rows`
 * only when ready).
 */
export function salesTaxLabel(
  list: { phase: string; rows?: readonly SalesTaxGroupRow[] },
  code: string | null,
): string {
  if (!code) return '';
  if (list.phase !== 'ready') return code;
  const row = list.rows?.find((candidate) => candidate.code === code);
  if (!row) return code;
  return codeLabel(row.code, row.description);
}
